<script>
  // Props for the CTA section customization
  export let heading = 'Want to use AI safely in your business? See how palma.ai can help.';
  export let highlightedText = 'palma.ai';
  export let subtext =
    "Our mission is to enable everyone's journey to maximum productivity while ensuring prompt safety!";
  export let emailButtonText = 'Leave us an Email';
  export let callButtonText = 'Schedule a Call';
  export let callButtonLink = 'https://meetings-eu1.hubspot.com/patrick-gruhn';
  import { Modal } from 'flowbite-svelte';
  import ContactForm  from '$lib/components/ContactForm.svelte';

   // State variables
   let modalOpen = false;
  

</script>

<section class="bg-gray-100 dark:bg-gray-800">
  <div class="mx-auto max-w-screen-xl px-4 py-8 sm:py-16 lg:px-6">
    <div class="mx-auto max-w-screen-md text-center">
      <!-- Heading with highlighted text -->
      <h2 class="mb-4 text-4xl font-extrabold tracking-tight text-gray-900 dark:text-white">
        {heading.split(highlightedText)[0]}
        <span class="text-primary-600 dark:text-primary-600">{highlightedText}</span>
        {heading.split(highlightedText)[1]}
      </h2>

      <!-- Subtext -->
      <p class="mb-6 font-light text-gray-500 dark:text-gray-400 md:text-lg">{subtext}</p>

      <!-- Buttons -->
      <div class="inline-flex flex-col justify-center space-y-4 sm:flex-row sm:space-x-4 sm:space-y-0">
        <!-- Email Button -->
        <button
          on:click={() => (modalOpen = true)}
          class="inline-flex items-center justify-center rounded-lg bg-primary-600 px-4 py-2.5 text-center text-base font-medium text-white hover:bg-primary-700 focus:ring-4 focus:ring-primary-300 dark:focus:ring-primary-900"
        >
          {emailButtonText}
        </button>

        <!-- Schedule Call Button -->
        <a
          href={callButtonLink}
          target="_blank"
          rel="noopener noreferrer"
          class="inline-flex items-center justify-center rounded-lg border border-gray-300 px-4 py-2.5 text-center text-base font-medium text-gray-900 hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 dark:border-gray-600 dark:text-white dark:hover:bg-gray-700 dark:focus:ring-gray-600"
        >
          <svg class="-ml-1 mr-2 h-5 w-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z"
            ></path>
          </svg>
          {callButtonText}
        </a>
      </div>
    </div>
  </div>

  <!-- Modal Container -->
  <Modal bind:open={modalOpen} outsideclose  >
    <div class="max-w-3xl overflow-hidden rounded-lg bg-white dark:bg-gray-800 ">
    <ContactForm></ContactForm>
    </div>
  </Modal>
</section>

<style>
  .hidden {
    display: none;
  }
</style>
